import type { PopupState } from 'material-ui-popup-state/hooks';
import { createStore } from './store-creators';

type PopoverFns = { open: () => void; close: () => void };

type PopoverStoreState = {
  popover: PopupState;
  popovers: Record<string, PopoverFns>;
  activePopoverId: string | null;
};

type PopoverStoreActions = {
  registerPopover: (id: string, fns: PopoverFns) => void;
  unregisterPopover: (id: string) => void;
  setActivePopover: (id: string) => void;
  openPopover: (id: string) => void;
};

export const usePopoverStore = createStore<
  PopoverStoreState & PopoverStoreActions
>((set, get) => ({
  popover: null,
  popovers: {},
  activePopoverId: null,

  registerPopover: (id, fns) => {
    set((state) => ({ popovers: { ...state.popovers, [id]: fns } }));
  },

  unregisterPopover: (id) => {
    set((state) => {
      const { [id]: _, ...rest } = state.popovers;
      return { popovers: rest };
    });
  },

  setActivePopover: (id) => {
    const { activePopoverId, popovers } = get();
    // Close currently active popover if different (mutual exclusion)
    if (activePopoverId && activePopoverId !== id) {
      popovers[activePopoverId]?.close();
    }
    set({ activePopoverId: id });
  },

  openPopover: (id) => get().popovers[id]?.open()
}));
